const TOOL_MESSAGES = {
  get_documentation: 'Looking up documentation...',
  execute_smart_endpoint: 'Running smart endpoint...',
  propose_source: 'Preparing source proposal...',
  propose_test: 'Preparing test proposal...'
}

function snapshotWorkspace (workspaceContext) {
  if (!workspaceContext) return { source: '', tests: '', endpointConfig: '' }

  const tests = workspaceContext.testsRef?.current
  const testsSerialized = Array.isArray(tests) && tests.length > 0
    ? JSON.stringify(tests.map(t => ({
      name: t.name,
      mode: t.testMode,
      input: t.input,
      mockResponses: t.responses,
      assertions: t.assertions,
      status: t.status || null,
      lastRunMs: t.lastRunMs ?? null
    })), null, 2)
    : ''

  const endpointConfig = workspaceContext.endpointConfig
    ? JSON.stringify(workspaceContext.endpointConfig)
    : ''

  return {
    source: workspaceContext.source || '',
    tests: testsSerialized,
    endpointConfig
  }
}

function snapshotToAttachments (snapshot) {
  const attachments = []
  if (snapshot.source) attachments.push({ name: 'source', content: snapshot.source })
  if (snapshot.tests) attachments.push({ name: 'tests', content: snapshot.tests })
  if (snapshot.endpointConfig) attachments.push({ name: 'endpointConfig', content: snapshot.endpointConfig })
  return attachments
}

export function createAttachmentTracker () {
  let lastSent = null

  return {
    buildAttachments (workspaceContext) {
      const current = snapshotWorkspace(workspaceContext)

      if (lastSent &&
        current.source === lastSent.source &&
        current.tests === lastSent.tests &&
        current.endpointConfig === lastSent.endpointConfig
      ) {
        return []
      }

      lastSent = current
      return snapshotToAttachments(current)
    },

    reset () {
      lastSent = null
    }
  }
}

export const AGENT_CONFIGS = {
  'smart-endpoints-designer': {
    agentId: 'smart-endpoints-designer',
    label: 'Smart Endpoint Designer',
    placeholder: 'Describe what you want to build...',
    editPlaceholder: 'Describe what you want to change...',
    toolMessages: TOOL_MESSAGES
  }
}

export function getAgentConfig (agentId) {
  return AGENT_CONFIGS[agentId] || AGENT_CONFIGS['smart-endpoints-designer']
}
